import React, { useMemo, useState } from 'react';
import slugify from '../../../../../core/commom/slugify';
import { Button } from '../../../../../core/components/atoms/Button';
import {
  DropDownList,
  IDropDownItems,
} from '../../../../../core/components/molecules/DropDownList';
import { IWeekSchedule } from '../../../model/weekSchedule';
import { useDailyScheduleContentStore } from '../../../stores/useDailyScheduleContent';
import { DisciplineScheduleSlot } from '../DisciplineScheduleSlot';
import { useParams } from 'react-router-dom';
import { Icon } from '../../../../../core/components/atoms/Icon';

export interface IResponsiveHeader {
  weekSchedule: IWeekSchedule;
  onDaySelect?: (day: IDropDownItems) => void;
  onDisciplineSelect?: (discipline: string) => void;
}

const ResponsiveHeader: React.FC<IResponsiveHeader> = ({
  weekSchedule,
  onDaySelect,
  onDisciplineSelect,
}) => {
  const { scheduleId } = useParams();

  const {
    selectedDay,
    setSelectedDay,
    selectedDiscipline,
    setSelectedDiscipline,
  } = useDailyScheduleContentStore();

  const daysList: IDropDownItems[] = useMemo(() => {
    return weekSchedule.days.map((item) => ({
      id: item.id,
      title: item.title,
      subtitle: item.subtitle,
    }));
  }, [weekSchedule]);

  const disciplinesList = useMemo(() => {
    if (!selectedDay) return [];

    const day = slugify(selectedDay.title);
    const daySchedule =
      weekSchedule?.dias?.[day as keyof typeof weekSchedule.dias];

    return daySchedule || [];
  }, [weekSchedule, selectedDay]);

  const handleSelectDay = (day: IDropDownItems) => {
    if (onDaySelect) {
      onDaySelect(day);
    } else {
      setSelectedDay(day);
    }
  };

  const handleSelectDiscipline = (discipline: string) => {
    if (onDisciplineSelect) {
      onDisciplineSelect(discipline);
    } else {
      setSelectedDiscipline(discipline);
    }
  };

  return (
    <div className='flex flex-col gap-xl rounded-[32px] bg-color-lightest px-4 py-3 shadow-level-1 lg:hidden'>
      <div className='flex flex-row gap-xl'>
        <div className='col-span-1 flex flex-row items-center justify-start'>
          <Button
            iconType='material'
            variant='text'
            className='text-mono-color-black px-1'
            asLink={true}
            to={`/plano-adaptativo/${scheduleId}/hub`}
          >
            <span className='text-sm text-color-brand-primary'>Painel</span>
          </Button>
          <Icon
            Icon='chevron_right'
            type='material'
            className='text-mono-color-black'
          />
          <Button variant='text' className='text-mono-color-black px-1'>
            <span className='text-sm text-button-color-tertiary-disabled'>
              {`Semana ${weekSchedule?.semana}`}
            </span>
          </Button>
        </div>
        <div className='col-span-1  flex flex-1 items-center justify-center border-l-hairline border-mono-color-medium'>
          <DropDownList
            size='compact'
            items={daysList}
            onSelect={handleSelectDay}
            value={selectedDay}
          />
        </div>
      </div>
      <div className='flex flex-row gap-xl overflow-x-auto'>
        {disciplinesList.map((item) => (
          <DisciplineScheduleSlot
            title={item.title}
            disciplineSlug={item.nome}
            currentProgress={item.percentualConclusao}
            totalProgress={100}
            compact
            onClick={() => handleSelectDiscipline(item.nome)}
            key={item.nome}
            selected={selectedDiscipline === item.nome}
          />
        ))}
      </div>
    </div>
  );
};

export default ResponsiveHeader;
